interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  return (
    <footer
      className={`bg-[#020816] ${className || ''}`}
      style={{ borderTop: '0.5px solid rgba(255, 255, 255, 0.12)' }}
    >
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row px-6 md:px-[60px] py-6 md:py-12 justify-between items-center">
        <div
          className="text-white/25 text-sm font-normal leading-normal mb-4 md:mb-0"
          style={{ fontFamily: 'Outfit' }}
        >
          © 2026 CommerceMinder. Tüm hakları saklıdır.
        </div>

        <div className="flex items-center space-x-4 md:space-x-6">
          <a
            href="#"
            className="text-white/25 hover:text-white/40 transition-colors text-sm font-normal leading-normal"
            style={{ fontFamily: 'Outfit' }}
          >
            Gizlilik
          </a>
          <a
            href="#"
            className="text-white/25 hover:text-white/40 transition-colors text-sm font-normal leading-normal"
            style={{ fontFamily: 'Outfit' }}
          >
            Şartlar
          </a>
          <a
            href="https://www.linkedin.com/company/commerceminder/posts/?feedView=all"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/25 hover:text-white/40 transition-colors text-sm font-normal leading-normal"
            style={{ fontFamily: 'Outfit' }}
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
